export default __webpack_public_path__ + "static/media/sharepoint4.702277aa.png";